import './style.scss';
import './countryresult.scss';
import { useEffect, useRef } from "react";
import { useState } from 'react';
import { IFeature } from '@esri/arcgis-rest-types';
import { IRelatedRecordGroup } from '@esri/arcgis-rest-feature-layer';
import QueryService from '../../shared/queryService';
import ConfigService from '../../shared/configService';
import { Map } from "./components/Map";
import Utils from '../../shared/utils';
import { useTranslation } from "react-i18next";
import IReport from '../../models/IReport';
import { IDashboard, IGADM_0, IGADM_1, IReportMain } from '../../models/IConfig';
import LoadingOverlay from 'react-loading-overlay';
import { useLocation } from 'react-router-dom';
import queryString from 'query-string';
import DetailDashboard from './DetailDashboard';
import { ReportList } from './components/ReportList';

const Dashboard = () => {

    const { t } = useTranslation('dashboard');
    const mapRef = useRef<any>();

    const gadm0Config: IGADM_0 = ConfigService.getConfig().agol.gadmLayers.gadm_0;
    const gadm1Config: IGADM_1 = ConfigService.getConfig().agol.gadmLayers.gadm_1;
    const reportMainConfig: IReportMain = ConfigService.getConfig().agol.operationalLayers.reportMain;
    const dashboardConfig: IDashboard = ConfigService.getConfig().dashboard;

    interface IDataState {
        reports: IReport[],
        countries: IFeature[],
        states: IFeature[],
        reportYears: String[],
        totalCountries: number,
        TotalHAUnderRestoration: string,
        endorsers: string
    }

    interface ILocalState {
        selectedGID: string,
        selectedYear: string,
        reportedYear: string;
        reportsLoaded: boolean,
        queryParams: any
    }

    /**
   * State
   */
    const [showDetailDashboard, setShowDetailDashboard] = useState(false);

    const handleDetailDashboardClose = () => {
        setShowDetailDashboard(false);
        mapRef.current.goToInitialExtent();
    }

    const handleDetailDashboardShow = (gid: string, year: string, reportedYear: string) => {
        let obj: any = { ...state };
        obj["selectedGID"] = gid;
        obj["selectedYear"] = year;               
        obj["reportedYear"] = reportedYear;
        setState(obj);
        setShowDetailDashboard(true);
    }

    const [dataState, setDataState] = useState<IDataState>({
        reports: [],
        countries: [],
        states: [],
        reportYears: [],
        totalCountries: 0,
        TotalHAUnderRestoration: "",
        endorsers: ""
    });

    const [state, setState] = useState<ILocalState>({
        selectedGID: 'NONE',
        selectedYear: '',
        reportedYear: '',
        reportsLoaded: false,
        queryParams: queryString.parse(useLocation().search)        
    });

    useEffect(() => {
        const currentYear: number = new Date().getFullYear();
        getData(currentYear);

    }, []);

    const onSelectedFeature = (countryOrStateName: string) => {
        let obj: any = { ...state };
        obj["selectedGID"] = countryOrStateName;
        setState(obj);
    }

    const getReportYears = async (reports: IReport[]) =>{ 
        const where = "reporting_entity_type = '1' OR reporting_entity_type = '' OR reporting_entity_type =null";
        //const where = '1=1'
        const records = await QueryService.queryFeatures(Utils.getReportLayerQuery(ConfigService.getConfig().agol?.operationalLayers.reportMain.index), where, false, [ConfigService.getConfig().agol?.operationalLayers.reportMain.fields.repYear], `${ConfigService.getConfig().agol?.operationalLayers.reportMain.fields.repYear} ASC`, null, false);
        const distinctYears: String[] = records.map((record: IFeature) => record.attributes[ConfigService.getConfig().agol?.operationalLayers.reportMain.fields.repYear]).filter((value: any, index: any, self: string | any[]) => self.indexOf(value) === index && value > 0 && value != 2020 && value != 2021);
        return distinctYears;
    };

    const getRelatedFeatures = async (sourceFeatures: IFeature[], relatedTableName: String, url: string, relationshipId: number, objectIds: number[], outFields: '*' | string[] | undefined = '*'): Promise<IFeature[]> => {
        try {
            let resulfeatures = sourceFeatures;

            if (objectIds && objectIds.length > 0) {
                const relatedRecords: IRelatedRecordGroup[] = await QueryService.queryRelatedFeatures(url, relationshipId, objectIds, false, outFields, '', false);

                if (relatedRecords && relatedRecords.length > 0) {

                    resulfeatures = sourceFeatures.map((feature: IFeature) => {

                        const relatedRecord: IRelatedRecordGroup | undefined = relatedRecords.find((item: IRelatedRecordGroup) => item.objectId == feature.attributes[ConfigService.getConfig().agol?.operationalLayers.reportMain.fields.objectid]);
                        if (relatedRecord && relatedRecord.relatedRecords && relatedRecord.relatedRecords.length > 0) {
                            /*for (const key in  relatedRecord.relatedRecords[0].attributes) 
                                feature.attributes[relatedTableName+"."+ key] = relatedRecord.relatedRecords[0].attributes[key];
                            */
                            if (typeof outFields === "object") {
                                for (let i = 0; i < outFields.length; i++) {
                                    //outFields.map( (field:String) => {
                                    const field = outFields[i];
                                    const sum = relatedRecord.relatedRecords.reduce((prev: number, current: IFeature) => {
                                        return prev + (current.attributes[field] as number);
                                    }, 0);
                                    feature.attributes["sum_" + field] = sum;
                                }
                            }

                        }
                        return feature;

                    });

                }

            }
            return resulfeatures;

        } catch (err: any) {
            console.error(err);
            return Promise.reject(err);
        }
    }

    const onselectedGID = async (countryOrState: string) => {        
        let reported_year = await getCountryOrStateYear(countryOrState, state.selectedYear);      
        if(reported_year.length > 0)
        {
            state.reportedYear = reported_year[0].attributes.rep_year;
        }
        else
        {
            state.reportedYear = state.selectedYear;
        }
        handleDetailDashboardShow(countryOrState, state.selectedYear, state.reportedYear)
    }

    const getCountryOrStateYear = async (countryOrState: string, year: string) => {  
        let records: IFeature[];        
        const where = `(${reportMainConfig.fields.gid0} = '${countryOrState}' or ${reportMainConfig.fields.gid1} = '${countryOrState}')`;

        records = await QueryService.queryFeatures(Utils.getReportLayerQuery(ConfigService.getConfig().agol?.operationalLayers.reportMain.index), where, false, '*', ``, null, false);
        if(records.length > 1)
        {            
            const where = `${reportMainConfig.fields.repYear} = '${year}' and (${reportMainConfig.fields.gid0} = '${countryOrState}' or ${reportMainConfig.fields.gid1} = '${countryOrState}')`;
            records = await QueryService.queryFeatures(Utils.getReportLayerQuery(ConfigService.getConfig().agol?.operationalLayers.reportMain.index), where, false, '*', ``, null, false);
        }       
        return records;
    };

    const getData = async (year: number) => {
        Utils.setStateValue("reportsLoaded", false, state, setState);
        let where:any = '';
        if(year == 2022)
        {
            where = `${ConfigService.getConfig().agol?.operationalLayers.reportMain.fields.repYear}` + " IN (2020,2021,2022) and published = 1 and (reporting_entity_type = 1 OR reporting_entity_type = null OR reporting_entity_type = '')"
        }
        else
        {
            where = `${ConfigService.getConfig().agol?.operationalLayers.reportMain.fields.repYear}` + ' = ' + year.toString() + " and published = 1 and (reporting_entity_type = 1 OR reporting_entity_type = null OR reporting_entity_type = '')"
        }
        const sort = `${ConfigService.getConfig().agol?.operationalLayers.reportMain.fields.repYear} DESC, ${ConfigService.getConfig().agol?.operationalLayers.reportMain.fields.name0} ASC `
        let reportFeatures = await QueryService.queryFeatures(Utils.getReportLayerQuery(ConfigService.getConfig().agol?.operationalLayers.reportMain.index), where, false, '*', sort, null, false);
        const objectIdsReports: number[] = reportFeatures.map((feat: IFeature) => { return feat.attributes[ConfigService.getConfig().agol?.operationalLayers.reportMain.fields.objectid] });
        //query to related ReportRB
        reportFeatures = await getRelatedFeatures(reportFeatures, ConfigService.getConfig().agol?.operationalLayers.reportMain.relationships.reportRb.toString(), Utils.getReportLayerQuery(ConfigService.getConfig().agol?.operationalLayers.reportMain.index), ConfigService.getConfig().agol?.operationalLayers.reportMain.relationships.reportRb, objectIdsReports, ["ha_under_resto", "co2_sequestered", "eco_jobs_created"]);
        reportFeatures = await getRelatedFeatures(reportFeatures, ConfigService.getConfig().agol?.operationalLayers.reportMain.relationships.reportFinancialFlows.toString(), Utils.getReportLayerQuery(ConfigService.getConfig().agol?.operationalLayers.reportMain.index), ConfigService.getConfig().agol?.operationalLayers.reportMain.relationships.reportFinancialFlows, objectIdsReports, ["amount"]);
        //const relatedRecordsReportFinancialFlows: IFeature[] = await getRelatedFeatures(Utils.getReportLayerQuery(ConfigService.getConfig().agol?.operationalLayers.reportMain.index), ConfigService.getConfig().agol?.operationalLayers.reportMain.relationships.reportFinancialFlows, objectIdsReports);
 
        const reports: IReport[] = reportFeatures.map((feat: IFeature) => {

            const id: number = Number(feat.attributes[reportMainConfig.fields.objectid]);
            const year: number = Number(feat.attributes[reportMainConfig.fields.repYear]);
            const gid0: String = String(feat.attributes[reportMainConfig.fields.gid0]);
            const gid1: String = String(feat.attributes[reportMainConfig.fields.gid1]);
            const name0: string = feat.attributes[reportMainConfig.fields.name0];
            const name1: string = feat.attributes[reportMainConfig.fields.name1];
            const published: boolean = feat.attributes[reportMainConfig.fields.published];
            const submitted: boolean = feat.attributes[reportMainConfig.fields.submitted];                                   

            const zone: string = name1 ? `${name1} (State)` : `${name0} (Country)`;
            const status: any = published && submitted ? 'Published' : !published && submitted ? 'Submitted' : 'Saved';
            let attr: any = {};
            for (const key in feat.attributes)
                attr[key] = feat.attributes[key];
            attr.gid0 = gid0;
            attr.gid1 = gid1;
            attr.name0 = name0;
            attr.name1 = name1;
            attr.year = year;            
            attr.zone = zone;
            attr.clickable = false;
            if (feat.attributes[reportMainConfig.fields.gid1]) {
                attr.clickable = true;
            } else if (feat.attributes[reportMainConfig.fields.gid0]) {
                attr.clickable = true;
            }

            return attr;
        });

        const distinctGID1: Array<String> = reports.map((report: any) => report.gid1).filter((value, index, self) => self.indexOf(value) === index);
        const distinctGID0: any = reports.filter((report: any) => (report.gid1 == 'null' || report.gid1 == '')).map((report: any) => report.gid0);
        
        let countries: IFeature[] = await QueryService.queryFeatures(Utils.getGADMLayerQuery(gadm0Config.index), gadm0Config.fields.gid0 + " IN ('" + distinctGID0.join("','") + "')", true, '*', '', null, false);
        let states: IFeature[] = await QueryService.queryFeatures(Utils.getGADMLayerQuery(gadm1Config.index), gadm1Config.fields.gid1 + " IN ('" + distinctGID1.join("','") + "')", true, '*', '', null, false);
        //fill countries features with related features
        countries = countries.map((country: IFeature) => {
            const report: any | undefined = reports.find((item: any) => item.gid0 == country.attributes[gadm0Config.fields.gid0]);
            if (report)
                for (const key in report)
                    if (key != "OBJECTID")
                        country.attributes[key] = report[key];
            return country;
        });
        states = states.map((state: IFeature) => {
            const report: any | undefined = reports.find((item: any) => item.gid1 == state.attributes[gadm1Config.fields.gid1]);
            if (report)
                for (const key in report)
                    if (key != "OBJECTID")
                        state.attributes[key] = report[key];
            return state;
        });
        
        const distinctYears = await getReportYears(reports);
        
        if ((!countries.length && !states.length) && distinctYears.length && Number(distinctYears[distinctYears.length - 1]) !== year) {
            getData(Number(distinctYears[distinctYears.length - 1]));
            return;
        }

        const total_sum_ha_under_resto = reportFeatures.reduce(function (prev: number, current: IFeature) {
            //return prev + current.attributes["sum_ha_under_resto"]
            if(current.attributes["sum_ha_under_resto"]!=undefined)
            {
                return prev + current.attributes["sum_ha_under_resto"]
            }
            else
            {
                return prev;
            }
        }, 0);

        setDataState({
            reports: reports,
            countries: countries,
            states: states,
            totalCountries: reports.length,
            reportYears: distinctYears,
            TotalHAUnderRestoration: total_sum_ha_under_resto.toLocaleString(),
            endorsers: "+40"
        });

        // Set selected year
        let obj: any = { ...state };
        obj["selectedYear"] = year.toString();
        //obj["reportedYear"] = reportedYear.toString();
        obj["reportsLoaded"] = true;
        setState(obj);
    };

    return (
        <>
            <div className={`dashboardDiv ${showDetailDashboard ? "notdisplay" : ""}`}>
                <div className="page-header">
                    <div className="contained">
                        <span className="page-title">{t('title')}</span>
                    </div>
                </div>
                <div className="content-wrapper">
                    {dataState.reportYears.length > 0 &&
                        <div className="country-result">
                            <div className="contained">
                                <div className="info">
                                    <div className="option-selectors">
                                        <div className="year-selector">
                                            <label>{t('filter.selectYearLabel')}</label>
                                            <select className="mediumText small"
                                                onChange={(e) => { getData(e.target.value as unknown as number) }} >
                                                {<option value="" disabled key="">{t('filter.selectYearPlaceHolder')}</option>}
                                                {dataState.reportYears.map((year: any) => <option value={year} key={year} selected={year == dataState.reportYears[dataState.reportYears.length - 1] ? true : false} >{year}</option>)}
                                            </select>
                                        </div>
                                    </div>
                                    <div className="info-text">
                                        <p>
                                            <strong>{dataState.totalCountries}</strong>
                                            <span>{dataState.totalCountries && dataState.totalCountries > 1 ? t('filter.totalCountriesMultiple') : t('filter.totalCountriesSingle')}</span>
                                        </p>
                                    </div>
                                    <div className="info-text">
                                        <p>
                                            <strong>{dataState.TotalHAUnderRestoration}</strong>
                                            <span>{t('filter.totalhaUnderRestoration')}</span>
                                        </p>
                                    </div>
                                    <div className="info-text">
                                        <p>
                                            <strong>{dashboardConfig.totalEndorsers}</strong>
                                            <span>{t('filter.endorsers')}</span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    <div className="hero">
                        <div className="contained">
                            <div className="image-wrapper">
                                {state.reportsLoaded &&
                                    <>
                                        <Map ref={mapRef} reports={dataState.reports} countries={dataState.countries} states={dataState.states} onSelectedFeature={onSelectedFeature} onShowDetails={handleDetailDashboardShow} />
                                    </>
                                }
                            </div>
                        </div>
                    </div>
                    {state.reportsLoaded &&
                        <>
                            <ReportList  reports={dataState.reports} selectedGID={state.selectedGID} onClickedCountryState={onselectedGID} />
                        </>
                    }
                    <LoadingOverlay
                        active={!state.reportsLoaded}
                        spinner
                        text={!state.reportsLoaded ? t('loading') : ''} >
                    </LoadingOverlay>
                </div>

            </div>
            {showDetailDashboard && state.selectedGID && state.selectedYear &&
                <DetailDashboard selectedGID={state.selectedGID} year={state.reportedYear} onClose={handleDetailDashboardClose} />
            }
        </>
    )
};

export default Dashboard;

